import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-ms-history-details-table",
	templateUrl: "./ms-history-details-table.component.html",
	styleUrls: ["./ms-history-details-table.component.css"],
})
export class MsHistoryDetailsTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateFilters();
	}

	ngOnChanges() {
		this.UpdateFilters();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() lstVisitorPassDetail: any = [];
	@Input() loading: any = false;

	pagerows: any = 5;
	pagefirst: any = 0;

	SelectedVisitorPassDetail: any;

	lstScanStation: any = [];
	lstFacility: any = [];
	lstVisitorPassDetailStatusDesc: any = [];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	UpdateFilters() {
		this.SelectedVisitorPassDetail = null;

		this.lstScanStation = Array.from(new Set(this.lstVisitorPassDetail.map((item: any) => item.ScanStation))).sort();
		this.lstFacility = Array.from(new Set(this.lstVisitorPassDetail.map((item: any) => item.Facility))).sort();
		this.lstVisitorPassDetailStatusDesc = Array.from(new Set(this.lstVisitorPassDetail.map((item: any) => item.VisitorPassDetailStatusDesc))).sort();
	}

	////////////////////////////////////////////
}
